import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {siteSelector, useGetSiteQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useEffect, useMemo, useState} from "react";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {SiteProfile} from "../../components/profile/SiteProfile/SiteProfile";
import {useApp} from "../../providers/RegionProvider/RegionProvider";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const SiteProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage message={"Site Not Found"}/>
    );
  }

  return <SiteProfilePage id={id}/>;
};

export const SiteProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const navigate = useNavigate()
  const {pathname, search, state} = useLocation()
  const {appCategory} = useApp()

  useEffect(() => {
    navigate(pathname + search, {replace: true, state: {...state, category: appCategory?.code}})
  }, [])

  const selectSite = useMemo(() => {
    return siteSelector()
  }, []);

  const {site, isFetching} = useGetSiteQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      site: selectSite(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage permissions={["site_view"]} entity={site} isLoading={isFetching} onAccess={setAccess}>
      {(entity) => (
        <SiteProfile site={entity}/>
      )}
    </EntityProfilePage>
  )
};
